var map = {
	"./step-1-ar.png": 1243,
	"./step-1-en.png": 1244,
	"./step-2-ar.png": 1245,
	"./step-2-en.png": 1246,
	"./step-3-ar.png": 1247,
	"./step-3-en.png": 1248,
	"./step-4.png": 1249,
	"./step-5-ar.png": 1250,
	"./step-5-en.png": 1251
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1242;